var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddTitleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.209,
    height: 27.201,
    viewBox: "0 0 27.209 27.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_78",
    "data-name": "Union 78",
    d: "M0,13.6A13.6,13.6,0,1,1,13.6,27.2,13.614,13.614,0,0,1,0,13.6Zm2.109,0A11.5,11.5,0,1,0,13.6,2.1,11.509,11.509,0,0,0,2.109,13.6Zm10.439,5.172V14.561H8.334a1.054,1.054,0,0,1,0-2.107h4.215V8.234a1.056,1.056,0,0,1,2.111,0v4.219h4.209a1.054,1.054,0,1,1,0,2.107H14.66v4.211a1.056,1.056,0,1,1-2.111,0Z",
    fill: "#284866"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTitleIcon);
export default __webpack_public_path__ + "static/media/add-title-icon.4746a10173ae275ac2aae74d8bfb2bd3.svg";
export { ForwardRef as ReactComponent };